module.exports = __webpack_public_path__ + "assets/5b2e07c997514893202b04023c31f3e5.mp3";